import { render, staticRenderFns } from "./OrderTableElementPagination.vue?vue&type=template&id=b7eb91be&"
import script from "./OrderTableElementPagination.vue?vue&type=script&lang=js&"
export * from "./OrderTableElementPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports